module.exports = __webpack_public_path__ + "img/63.25b144c8.jpg";